export default __webpack_public_path__ + "static/media/fontawesome-webfont.1e59d233.ttf";